import React, { FunctionComponent } from 'react';
import styles from './Loader.module.scss';
import { CircularProgress } from '@material-ui/core';

interface Props {
  overlay?: boolean;
  smallSize?: boolean;
  mediumSize?: boolean;
  loaderText?: string;
}

const Loader: FunctionComponent<Props> = ({
  overlay,
  smallSize,
  loaderText,
  mediumSize,
}) => {
  return (
    <div
      className={overlay ? styles.OverlayLoader : styles.Loader}
      data-testid="loader-spinner"
    >
      <CircularProgress
        color="inherit"
        size={smallSize ? 15 : mediumSize ? 20 : 40}
        data-testid="circular-progress"
      />
      {loaderText && <div className={styles.loaderText}>{loaderText}</div>}
    </div>
  );
};

export default Loader;
